import { IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { Link } from "react-router-dom";

import { SubActivityJudgeApi, SubActivityJudgeSearch, SubActivityJudgeGridDto } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { EmailButton, SearchTablePage } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface ISubActivityJudgePageProps {
  subActivityId: number;
}

export const SubActivityJudgePage: React.FunctionComponent<ISubActivityJudgePageProps> = ({ subActivityId }) => {
  const api = useApiService(SubActivityJudgeApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: SubActivityJudgeGridDto) => (
          <Link target="_blank" to={`${ERoutes.people}/${row.personId}/detail/view`}>
            {row.name}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Language),
        fieldName: "language",
      },
      {
        header: () => t(ETLCodes.Email),
        fieldName: "email",
        render: (value: SubActivityJudgeGridDto) => <EmailButton email={value.email} />,
      },
      {
        header: () => t(ETLCodes.PhoneNumber),
        fieldName: "phoneNumber",
      },
      {
        header: () => t(ETLCodes.MobilePhoneNumber),
        fieldName: "mobilePhoneNumber",
      },
    ],
    [t]
  );
  const search = React.useCallback(
    (sObj) =>
      api.baseSearch(
        SubActivityJudgeSearch.fromJS({
          ...sObj,
          languageId: currentLanguage.languageId,
          subActivityId: subActivityId,
        })
      ),
    [api, currentLanguage.languageId, subActivityId]
  );

  const getSearchCriterias = React.useCallback(() => api.getSearchCriterias(true), [api]);
  return (
    <SearchTablePage
      columns={columns}
      getCriteriasFunction={getSearchCriterias}
      searchFunction={search}
      exportFunction={(sObj) =>
        api.exportXlsFile(
          SubActivityJudgeSearch.fromJS({
            ...sObj,
            languageId: currentLanguage.languageId,
            subActivityId: subActivityId,
          })
        )
      }
      sortKeys={{ lastName: "ASC" }}
      withCard={false}
      breadCrumbs={[{ text: t(ETLCodes.Judges) }]}
    />
  );
};
